import { useEffect, useRef, useState } from 'react';
import SockJS from 'sockjs-client';
import { Client } from '@stomp/stompjs';
import { useNotifications } from './NotificationContext';

export default function NotificationStream() {
  const { pushNotification } = useNotifications();
  const pushRef = useRef(pushNotification);
  
  const [authToken, setAuthToken] = useState(null);

  useEffect(() => { pushRef.current = pushNotification; }, [pushNotification]);

  useEffect(() => {
    const checkToken = () => {
      const raw = sessionStorage.getItem('currentSession');
      const session = raw ? JSON.parse(raw) : null;
      if (session?.access_token !== authToken) {
        setAuthToken(session?.access_token);
      }
    };

    checkToken();

    const interval = setInterval(checkToken, 1000); 
    return () => clearInterval(interval);
  }, [authToken]);

  useEffect(() => {
    if (!authToken) return;

    console.log("Token detected, initiating WebSocket...");

    const client = new Client({
      webSocketFactory: () => new SockJS(`${process.env.REACT_APP_API_URL}/ws`),
      reconnectDelay: 5000,
      heartbeatIncoming: 4000,
      heartbeatOutgoing: 4000,
      connectHeaders: { 
        Authorization: `Bearer ${authToken}` 
      },
      onConnect: () => {
        console.log("WebSocket Connected!");
        client.subscribe('/user/queue/notification', (msg) => {
          const payload = JSON.parse(msg.body);
          pushRef.current(payload);
        });
      },
    });

    client.activate();

    return () => {
      console.log("Deactivating WebSocket...");
      client.deactivate();
    };
  }, [authToken]);

  return null;
}